function toutou_xy_temp(myJson,zoom,ctx=undefined){

  //Argument optionel
  if (zoom!=null){
    var my_zoom=zoom;
  } else {
    var my_zoom=0;
  }

  // Donnees de MySQL
  var ni       = myJson.hhh.length; 
  var data     = new Array(ni);
  var data2    = new Array(ni);
  var hhh      = new Array(ni);
  var time_label=new Array(ni); 
  var aaaammjj = myJson.aaaammjj; 
  var hh       = myJson.hh; 
  var datev    = dateo;
  var my_fonts = new Toutou_Fonts();
  var tr       = new Toutou_Transform();
  var nptcub   = 9;

  for (var i=0; i < ni; i++) {
    data[i]=myJson.data1[i]*.01;
    data2[i]=data[i]-myJson.data2[i]*.01;
    hhh[i]=myJson.hhh[i];
  }

  pointsData['temp'] = [];

  // Espace autour de la boite du graphique en %
  var pil_w=.08;
  var pil_e=.01;
  var pil_s=.2;
  var pil_n=.15;

  if(ctx == undefined) ctx=set_canvas('toutou_xy_temp');

  tr.xrange(my_zoom,hhh);
  tr.ymin=data2.min();
  tr.ymax=data.max();
  dimx=tr.xmax-tr.xmin;
  tr.xmin=tr.xmin-.02*dimx;
  tr.xmax=tr.xmax+.02*dimx;
  dimy=tr.ymax-tr.ymin;
  tr.ymin=tr.ymin-.02*gxsize/gysize*dimy;
  tr.ymax=tr.ymax+.02*gxsize/gysize*dimy;
  
  incy=1;
  nj=(Math.floor(tr.ymax)-Math.ceil(tr.ymin)+1);      
  if(nj > 12){incy=2;}
  if(nj > 24){incy=5;}
  tr.ymax=Math.floor(tr.ymax);
  tr.ymax=tr.ymax+(incy - tr.ymax % incy);
  tr.ymin=Math.ceil(tr.ymin);
  tr.ymin=tr.ymin-(tr.ymin % incy + incy);  
  tr.ymin=tr.ymin - Math.abs(tr.ymin % incy);
  nj=(Math.floor(tr.ymax)-Math.ceil(tr.ymin)+1);

  
  tr.pix_margeg=Math.round((   pil_w)*gxsize)+.5;
  tr.pix_marged=Math.round((1.-pil_e)*gxsize)+.5;
  tr.pix_margeh=Math.round((   pil_n)*gysize)+.5;
  tr.pix_margeb=Math.round((1.-pil_s)*gysize)+.5;      
  
  tr.init(my_zoom);

  pointsData['temp_params'] = { xmin_pix: tr.d2px(tr.xmin), xmax_pix: tr.d2px(tr.xmax),
				ymin_pix: tr.d2py(tr.ymin), ymax_pix: tr.d2py(tr.ymax),
			        tt_col: 'blue', td_col:'green'};
  
  ctx.fillStyle = '#FFF';
  ctx.fillRect(0, 0, gxsize,gysize);

  tr.draw_model_zones(ctx, my_fonts, hhh, myJson.modele);

  // Titre principal
  ctx.font = my_fonts.principal;
  ctx.fillStyle = "#33A"; 
  ctx.textAlign="center";
  ctx.textBaseline="top";
  
  ctx.fillText('Date de départ : '+toutou_xy_titre_principal(dateo),.5*(tr.xmax_pix+tr.xmin_pix),0); 
  ctx.restore(); 
  
  // Titre secondaire
  ctx.font = my_fonts.legende;
  ctx.fillStyle = pointsData['temp_params'].tt_col;
  ctx.textAlign="left";
  ctx.textBaseline="bottom";
  ctx.fillText('Courbe bleue : température [C]',tr.xmin_pix,tr.ymax_pix-2); 
  ctx.textAlign="right";
  ctx.fillStyle = pointsData['temp_params'].td_col;
  ctx.fillText('Courbe verte : point de rosée [C]',tr.xmax_pix,tr.ymax_pix-2); 
  
  // xticks
  tr.xticks_jours(datev,hhh,ctx,my_fonts,my_zoom,{time_label});
  
  // yticks
  ctx.beginPath();
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "Black";
  ctx.strokeStyle = 'black';      
  ctx.textAlign="right";
  ctx.textBaseline="middle";
  xx=Math.round(tr.xmin_pix-.01*(tr.xmax_pix-tr.xmin_pix))+.5;
  for (var i=0; i < nj; i=i+incy) {	
    yy=Math.round(tr.d2py(Math.ceil(tr.ymin)+i))+.5;
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(xx,yy);
    ctx.fillText((Math.ceil(tr.ymin)+i)+' ',xx,yy);
  }
  ctx.stroke();
  
  // Lignes grises
  for (var i=0; i < nj; i=i+incy) {
    val=Math.ceil(tr.ymin)+i;
    yy=Math.round(tr.d2py(val))+.5;
    ctx.beginPath();
    ctx.strokeStyle = '#bbb';
    // Ligne rouge a 0C et 30C
    if(val == 0 | val == 30){ctx.strokeStyle = '#f00';}
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(tr.xmax_pix,yy);
    ctx.stroke();
  }
  
  // Tracer la courbe de Td
  ctx.beginPath();
  ctx.fillStyle = pointsData['temp_params'].td_col;
  ctx.strokeStyle = pointsData['temp_params'].td_col;
  ctx.moveTo(tr.d2px(hhh[tr.xind_min]),tr.d2py(data2[tr.xind_min]));      
  for (var i=tr.xind_min; i <= tr.xind_max; i++) {
    xx=tr.d2px(hhh[i]);
    yy=tr.d2py(data2[i]);
    //ctx.lineTo(xx,yy);
    ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
    pointsData['temp'].push({x:xx, y:yy, tl:time_label[i], tt:data[i], td:data2[i]});
  }
  res=toutout_cubic_mono(hhh,data2,nptcub);
  for(i=tr.xind_min*(nptcub+1);i<=tr.xind_max*(nptcub+1);i++){
    ctx.lineTo(tr.d2px(res.x[i]),tr.d2py(res.y[i]));
  }
  ctx.stroke();
  
  // Tracer T
  ctx.beginPath();
  ctx.fillStyle = pointsData['temp_params'].tt_col;
  ctx.strokeStyle = pointsData['temp_params'].tt_col;
  ctx.moveTo(tr.d2px(hhh[tr.xind_min]),tr.d2py(data[tr.xind_min]));      
  for (var i=tr.xind_min; i <= tr.xind_max; i++) {
    xx=tr.d2px(hhh[i]);
    yy=tr.d2py(data[i]);
    ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd)
    //ctx.lineTo(xx,yy);
    pointsData['temp'].push({x:xx, y:yy, tl:time_label[i], tt:data[i], td:data2[i]});
    
  }
  res=toutout_cubic_mono(hhh,data,nptcub);
  for(i=tr.xind_min*(nptcub+1);i<=tr.xind_max*(nptcub+1);i++){
    ctx.lineTo(tr.d2px(res.x[i]),tr.d2py(res.y[i]));
  }
  ctx.stroke();
  
}
